import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Records from "@/pages/Records";
import CustomerDetail from "@/pages/CustomerDetail";
import CariDashboard from "@/pages/CariDashboard";
import CariRecords from "@/pages/CariRecords";
import CariVadeler from "@/pages/CariVadeler";
import CariCustomer from "@/pages/CariCustomer";
import IcralikPanel from "@/pages/IcralikPanel";
import OdemeSozuOnaylar from "@/pages/OdemeSozuOnaylar";
import HacizGundemi from "@/pages/HacizGundemi";
import Applications from "@/pages/Applications";
import Shipments from "@/pages/Shipments";
import IcraDosya from "@/pages/IcraDosya";
import Users from "@/pages/Users";
import AccountSettings from "@/pages/AccountSettings";
import Denetim from "@/pages/Denetim";
import AuditLog from "@/pages/AuditLog";
import Ozet from "@/pages/Ozet";
import IlDisiHarc from "@/pages/IlDisiHarc";
import IlDisiKasa from "@/pages/IlDisiKasa";
import Kasa from "@/pages/Kasa";
import TahsilatRaporu from "@/pages/TahsilatRaporu";
import AvukatGorevlerim from "@/pages/AvukatGorevlerim";
import OdemeSozleri from "@/pages/OdemeSozleri";
import AltinPanel from "@/pages/AltinPanel";
import AltinCari from "@/pages/AltinCari";
import AltinCariCustomer from "@/pages/AltinCariCustomer";
import AltinMuhasebe from "@/pages/AltinMuhasebe";
import MutabakatIcra from "@/pages/MutabakatIcra";
import { IS_PREVIEW } from "@/lib/api";
import IdleTimeout from "@/components/IdleTimeout";
function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <IdleTimeout />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Navigate to="/login" replace />} />
            <Route
              path="/"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/kayitlar"
              element={
                <ProtectedRoute allow={["admin", "katip", "avukat"]}>
                  <Records />
                </ProtectedRoute>
              }
            />
            <Route
              path="/altin-panel"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <AltinPanel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/altin-cari"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <AltinCari />
                </ProtectedRoute>
              }
            />
            <Route
              path="/altin-cari/:name"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <AltinCariCustomer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/altin-muhasebe"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <AltinMuhasebe />
                </ProtectedRoute>
              }
            />
            {IS_PREVIEW && (
            <Route
              path="/icra-mutabakat"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <MutabakatIcra />
                </ProtectedRoute>
              }
            />
            )}
            <Route
              path="/basvurular"
              element={
                <ProtectedRoute>
                  <Applications />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sevkiyat"
              element={
                <ProtectedRoute>
                  <Shipments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cari-musteri/:name"
              element={
                <ProtectedRoute>
                  <CariCustomer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cari-panel"
              element={
                <ProtectedRoute adminOnly>
                  <CariDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cari"
              element={
                <ProtectedRoute>
                  <CariRecords />
                </ProtectedRoute>
              }
            />
            <Route
              path="/icralik"
              element={
                <ProtectedRoute>
                  <IcralikPanel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/odeme-sozu-onaylar"
              element={
                <ProtectedRoute adminOnly>
                  <OdemeSozuOnaylar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/haciz-gundemi"
              element={
                <ProtectedRoute allow={["admin", "katip", "avukat"]}>
                  <HacizGundemi />
                </ProtectedRoute>
              }
            />
            <Route
              path="/avukat-gorevlerim"
              element={
                <ProtectedRoute allow={["admin", "avukat"]}>
                  <AvukatGorevlerim />
                </ProtectedRoute>
              }
            />
            <Route
              path="/il-disi-harc"
              element={
                <ProtectedRoute allow={["admin", "katip", "avukat"]}>
                  <IlDisiHarc />
                </ProtectedRoute>
              }
            />
            <Route
              path="/il-disi-kasa"
              element={
                <ProtectedRoute adminOnly>
                  <Kasa />
                </ProtectedRoute>
              }
            />
            <Route
              path="/icra-tahsilat-rapor"
              element={
                <ProtectedRoute adminOnly>
                  <TahsilatRaporu />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cari-vadeler"
              element={
                <ProtectedRoute>
                  <CariVadeler />
                </ProtectedRoute>
              }
            />
            <Route
              path="/odeme-sozleri"
              element={
                <ProtectedRoute adminOnly>
                  <OdemeSozleri />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gorevlerim"
              element={
                <ProtectedRoute>
                  <Applications mineOnly />
                </ProtectedRoute>
              }
            />
            <Route
              path="/icra/:id"
              element={
                <ProtectedRoute allow={["admin", "katip", "avukat"]}>
                  <IcraDosya />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cari/:name"
              element={
                <ProtectedRoute adminOnly>
                  <CustomerDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/kullanicilar"
              element={
                <ProtectedRoute adminOnly>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/silme-kaydi"
              element={
                <ProtectedRoute adminOnly>
                  <AuditLog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ozet"
              element={
                <ProtectedRoute allow={["admin", "izleyici"]}>
                  <Ozet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/denetim"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <Denetim />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hesap-ayarlari"
              element={
                <ProtectedRoute>
                  <AccountSettings />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
